/** The Inspections feature route (SWOOP-378). An Inspections & Compliance module surface gated on `inspections:list`. */
export const INSPECTIONS_PATH = '/inspections';

/** Seeing the Inspections menu and its screens — held by the Inspector role. */
export const INSPECTIONS_LIST_PERMISSION = 'inspections:list';
